import React, { Component } from 'react';
import { debounce, isNumber } from 'lodash';
import Label from './Label.js';
import { mergeStyles } from 'wix-rich-content-common';
import Slider from './Slider.js';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';
import { i as infoIconStyles } from '../InfoIcon-8711d7eb.js';
import 'wix-rich-content-common/libs/Tooltip';
import '../Icons/InfoIcon.js';
import 'classnames';
import '../consts.js';

var css_248z = ".EzcYn{display:block}[dir] .EzcYn{margin-bottom:6px}.rJkeI{opacity:.5;pointer-events:none}.gz0qx{align-items:center;display:flex;flex-basis:auto;justify-content:space-between}.CCGTB{flex:1 1 auto}._1oFAg{box-sizing:border-box;flex:0 0 50px;font-family:inherit;font-size:14px;height:30px;max-width:55px}[dir] ._1oFAg{border:1px solid #ededed;border:1px solid var(--ricos-settings-inputs-border-color,rgba(0,0,0,.6));border-radius:3px;border-radius:var(--ricos-settings-inputs-border-radius,0);padding:.1em;text-align:center}[dir=ltr] ._1oFAg{margin-left:24px}[dir=rtl] ._1oFAg{margin-right:24px}._1oFAg::placeholder{color:var(--ricos-settings-inputs-placeholder-color,rgba(0,0,0,.6))}";
var styles = {"sliderWithInput_label":"EzcYn","sliderWithInput_readOnly":"rJkeI","sliderWithInput_content":"gz0qx","sliderWithInput_slider":"CCGTB","sliderWithInput_input":"_1oFAg"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
class SliderWithInput extends Component {
  constructor() {
    super(...arguments);
    this.styles = mergeStyles({ styles, theme: this.props.theme });
    this.id = `sld_${Math.floor(Math.random() * 9999)}`;
    this.state = { inputValue: this.props.defaultValue };
    this.handleInputChange = (event) => {
      const inputValue = event.target.valueAsNumber || 0;
      this.setState({ inputValue });
    };
    this.submitInputValueDebounced = debounce(() => {
      const inputValue = this.normalizeInputValue(this.state.inputValue);
      this.props.onChange(inputValue);
      this.setState({ inputValue });
    }, 800);
    this.submitInputValue = () => {
      const inputValue = this.normalizeInputValue(this.state.inputValue);
      this.props.onChange(inputValue);
      this.setState({ inputValue });
    };
    this.handleSliderChange = (inputValue) => {
      this.setState({ inputValue });
    };
    this.getInputMin = () => isNumber(this.props.inputMin) ? this.props.inputMin : this.props.min;
    this.getInputMax = () => isNumber(this.props.inputMax) ? this.props.inputMax : this.props.max;
    this.normalizeInputValue = (value) => Math.min(Math.max(this.getInputMin(), value), this.getInputMax());
  }
  render() {
    const {
      label,
      min,
      max,
      theme,
      sliderDataHook,
      inputDataHook,
      tooltipTextKey,
      t,
      languageDir
    } = this.props;
    const { inputValue } = this.state;
    let ariaProps = label ? { "aria-labelledby": `${this.id}_lbl` } : {};
    ariaProps = __spreadProps(__spreadValues({}, ariaProps), {
      "aria-valuemin": min,
      "aria-valuemax": max,
      "aria-valuenow": inputValue
    });
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: infoIconStyles.infoContainer }, label && /* @__PURE__ */ React.createElement(Label, { label, tooltipText: t == null ? void 0 : t(tooltipTextKey) })), /* @__PURE__ */ React.createElement("div", { className: this.styles.sliderWithInput_content }, /* @__PURE__ */ React.createElement(
      Slider,
      {
        theme,
        languageDir,
        value: inputValue,
        dataHook: sliderDataHook,
        onChange: this.handleSliderChange,
        onChangeCommitted: this.submitInputValue,
        min,
        max,
        className: this.styles.sliderWithInput_slider,
        ariaProps
      }
    ), /* @__PURE__ */ React.createElement(
      "input",
      __spreadProps(__spreadValues({
        tabIndex: 0,
        type: "number",
        value: inputValue,
        "data-hook": inputDataHook
      }, ariaProps), {
        onChange: this.handleInputChange,
        onBlur: this.submitInputValue,
        onKeyUp: this.submitInputValueDebounced,
        className: this.styles.sliderWithInput_input,
        min: this.getInputMin(),
        max: this.getInputMax(),
        step: "1",
        role: "spinbutton"
      })
    )));
  }
}
SliderWithInput.defaultProps = {
  min: 0,
  max: 100
};

export { SliderWithInput as default };
//# sourceMappingURL=SliderWithInput.js.map
